import { render, staticRenderFns } from "./TheProfileMenu.vue?vue&type=template&id=d4d38bec&"
import script from "./TheProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./TheProfileMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports